(function () {
    angular.module('tradersyard').component('tyUploadUserPicture', {
        // language=Angular2Html
        template:
            '<div ng-transclude></div>\n<div ng-show="$ctrl.isEnabled" class="upload-overlay" ng-click="$ctrl.onClick()">\n    <span class="icon-yard-add-image"></span>\n</div>\n<form name="$ctrl.uploadForm" hidden>\n    <input type="file"\n           accept="image/jpeg image/jpg"\n           ng-model="$ctrl.pictureInput"\n           flex-file64\n           flex-maxsize="5242880"\n           flex-end="$ctrl.uploadPicture"\n           flex-onerror="$ctrl.handleError" />\n</form>\n',
        bindings: {
            isEnabled: '<?',
            userId: '<',
            onSuccess: '&?',
        },
        transclude: true,
        controller: UploadUserPictureComponentController,
    });

    UploadUserPictureComponentController.$inject = ['$rootScope', '$scope', '$q', '$element', 'graph-user-factory'];

    function UploadUserPictureComponentController($rootScope, $scope, $q, $element, userApi) {
        var ctrl = this;

        ctrl.pictureInput = {};
        ctrl.uploadForm = {};

        ctrl.onClick = function () {
            // trigger file picker dialog
            $element.find('input[type=file]').click();
        };

        ctrl.uploadPicture = function (data) {
            if (ctrl.uploadForm.$invalid) return;

            _uploadPicture(ctrl.pictureInput, userApi, ctrl.userId)
                .then(function (attachmentData) {
                    return ctrl.onSuccess({ uploadedPicture: attachmentData });
                })
                .catch(function (error) {
                    $rootScope.$broadcast('graph-modal-show', {
                        title: 'Error',
                        content: error.data.data.photo,
                    });
                });
        };

        function _uploadPicture(imageData, userApi, userId) {
            return userApi
                .picture(userId)
                .upload({
                    name: imageData.name,
                    photo: imageData.base,
                })
                .then(function (response) {
                    var uploadedPictureId = response.data.data.id;
                    return userApi
                        .picture(userId)
                        .attach(uploadedPictureId)
                        .then(function (response) {
                            return response.data.state === 0 ? response.data.data : $q.reject();
                        });
                });
        }
    }
})();
